import React, { useState } from 'react'
import './Styles.css';

function EnquireForm1() {
  const [formData, setFormData] = useState({
    fullname: '',
    mobile: '',
    email: '',
    country: '',
    message: '',
    submitted: false, // this will control form and thankyou message
    isSubmitting: false, // this is to show the Submitting.
    
        errorMessage: null,
  });

  const toTitleCase = (str) => {
        return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const handleChange = (event) => {setFormData({...formData,[event.target.name]: event.target.value,});
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, submitted: true, isSubmitting: true, errorMessage: null });//initial state to show submitting
        
    fetch('https://api-3casoqxyqq-uc.a.run.app/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Success:', data); // after receiving the response from server, we can remove the Submitting state and show thankyou message
        setFormData(prevState => ({ ...prevState, isSubmitting: false }));      //we dont alter the submitted state so that it continues to show this page
      })
      .catch((error) => {    //if there is an error, we remove both submitted and submitting, this helps in going back to form
        setFormData({ ...formData, submitted: false, isSubmitting: false, errorMessage: 'Error submitting your query. Please try again.' });
        console.error('Error:', error);
    });
  };
  const handleHomeClick = () => {
    setFormData({
        fullname: '',
        mobile: '',
        email: '',
        country: '',
        message: '',
        submitted: false,
    });
  };
  
  return (
    <>
      <div className='BgEnquiryPg'>
        <div className='OnePxDiv'> </div>
        <div className="HeadEnquiryPg"> Set forth on your Aura Voyage </div>
      </div>

      <div className='EnqFormWid1Div'>
        <div className='EnqFormWid1'>
          {!formData.submitted ? (
            <div>
                {formData.errorMessage && <div style={{ color: 'red', marginBottom: '10px' }}>{formData.errorMessage}</div>} 
              <div className="HeadFormDiv"> Send us your basic details and your enquiry </div>
              
              <form className='EnquiryFormStyle' onSubmit={handleSubmit}>
                <label className='EnquiryLabel'> Full Name </label>
                <input className='EnquiryInput' type="text" name="fullname" value={formData.fullname} onChange={handleChange} required />
                <br />

                <label className='EnquiryLabel'> Mobile </label>
                <input className='EnquiryInput' type="text" name="mobile" value={formData.mobile} onChange={handleChange} required />
                <br />

                <label className='EnquiryLabel'> Email </label>
                <input className='EnquiryInput' type="email" name="email" value={formData.email} onChange={handleChange} required />
                <br />

                <label className='EnquiryLabel'> Country </label>
                <input className='EnquiryInput' type="text" name="country" value={formData.country} onChange={handleChange} required />
                <br />

                <label className='EnquiryLabel'> Are you looking for an Aura Voyage? Tell us more.. </label>
                <div className='EnquiryInputMsgDiv'>
                  <textarea className='EnquiryInputMsg' name="message" value={formData.message} onChange={handleChange} />
                </div>

                <button type="submit" className='ButtonEnquiry' style={{ cursor: 'pointer' }}>
                  Submit
                </button>
              </form>
            </div>
          ) : (
            <div className="success-message">
              <div className="HeadFormDiv">
                Thank you, {toTitleCase(formData.fullname)}!
                  <br /> {formData.isSubmitting ? 'Submitting...' : 'We will get back to you shortly.'} {/* if submitting show submitting else final success */}                
                </div>
                {!formData.isSubmitting && ( // this means if its not submitting then show the home button, else dont show it

                <a href="/" onClick={handleHomeClick} className='ButtonEnquiry' style={{ cursor: 'pointer' }}> Home
                </a>
                )}
                
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EnquireForm1;